import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Cart, CheckPaymentStatusResponse, Coupon, OrderFromCart, ShipmentMethod } from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class CartService {
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}
    addToCart(productId: string, skipErrorHandling = false) {
        const headers = new HttpHeaders({ 'Skip-Error-Handling': 'true' });
        return this.http.patch<Cart>(`${this.path}/cart/add-to-cart/`, { productId }, { headers: skipErrorHandling ? headers : null });
    }
    getCart() {
        return this.http.get<Cart>(`${this.path}/cart/get-my-cart/`);
    }

    removeFromCart(productId: string) {
        return this.http.delete<Cart>(`${this.path}/cart/remove-from-cart/${productId}`);
    }

    getShipmentOptions() {
        return this.http.get<ShipmentMethod[]>(`${this.path}/order/shipment-methods`);
    }

    createOrderFromCart(orderFromCart: OrderFromCart) {
        return this.http.post<Cart>(`${this.path}/order/create-from-cart`, orderFromCart);
    }

    getCartOrderStatus() {
        return this.http.get<CheckPaymentStatusResponse>(`${this.path}/order/cart-payment-status`);
    }

    addCouponToCart(coupon: Coupon) {
        return this.http.post<Cart>(`${this.path}/order/add-coupon`, coupon);
    }

    removeCouponToCart(coupon: Coupon) {
        return this.http.post<Cart>(`${this.path}/order/delete-coupon`, coupon);
    }
}
